export const audios = [
    {
        name: 'Northlane - Dante',
        music: require('./audios/Northlane-Dante.mp3'),
        creator: 'Northlane'
    },
    {
        name: 'P.O.D - Good by for now',
        music: require('./audios/POD-Good-by-for-now.mp3'),
        creator: 'P.O.D'
    },
    {
        name: 'Korn - Faget',
        music: require('./audios/Korn-Faget.mp3'),
        creator: 'Korn'
    },
    {
        name: 'System of a down - Hypnotize',
        music: require('./audios/Soad-Hypnotize.mp3'),
        creator: 'System of a Down'
    },
]